// The ONE desktop rail frame (RD-UI-RAILPIN-001, KAN-1179): `aside` (clips) >
// ONE scroll region (identity + cards) + the footer as the LAST child. The
// footer (a submit block from `L.railSubmitBlock` / `submitBlockStyle`) is
// outside the scroller, so the primary never moves while the rail scrolls and
// nothing blank can appear under it. Every web full-screen rail renders through
// this (FullScreenSummaryRail, DocumentPreviewRail, LogJobSummaryRail and its
// skeleton). Guard: `railFrame.guard.test.js`.
import { layoutStyles as L } from '../../../pages/logJobLayoutStyles';

/**
 * @param {object} props
 * @param {object} [props.style] - frame overrides (e.g. a raised z-index).
 * @param {object} [props.scrollStyle] - scroll-region overrides (e.g. a different gap).
 * @param {import('react').ReactNode} [props.footer] - the submit block; rendered LAST, outside the scroller.
 * @param {string} [props.testId]
 */
export default function RailFrame({ style = null, scrollStyle = null, footer = null, testId, children }) {
  return (
    <aside style={style ? { ...L.rail, ...style } : L.rail} data-testid={testId}>
      <div style={scrollStyle ? { ...L.railScroll, ...scrollStyle } : L.railScroll} data-cvx-rail-scroll="">
        {children}
      </div>
      {footer}
    </aside>
  );
}
